import { useQuery } from "@tanstack/react-query";
import { extractPaginatedCollection } from "../../utils/apiResponse";

/**
 * @param {object} deps
 * @param {(url: string, options: any) => Promise<any>} deps.callApiWithWorker
 * @param {string} deps.currentLang
 * @param {number} deps.pageIndex
 * @param {number} deps.pageSize
 */
export function useGetVocabsPaginated({
  callApiWithWorker,
  currentLang,
  pageIndex,
  pageSize,
}) {
  return useQuery({
    queryKey: ["vocabsPaginated", currentLang, pageIndex, pageSize],
    enabled: Boolean(callApiWithWorker && currentLang),
    queryFn: async () => {
      const url = `/api/vocabularyHub/getAll?language=${encodeURIComponent(
        currentLang,
      )}&page=${pageIndex}&size=${pageSize}`;

      const res = await callApiWithWorker(url, { method: "GET" });
      return extractPaginatedCollection(res);
    },
    keepPreviousData: true,
    staleTime: 10_000,
  });
}
